import React from 'react';
import { Trans } from 'react-i18next';
import { H3, Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const LegalHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="legal" t={t}>
      <Box mb={3}>
        <H3>Rechtsschutz</H3>
      </Box>

      <Box mb={2}>
        <Subtitle>Bitte geben Sie an, ob Sie eine gültige Rechtsschutzversicherung haben oder nicht.</Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Bei einigen Rechtsschutzversicherungen wird die Prüfung bei MINEKO
          <b>übernommen.</b>
          Bei unseren Rechtsschutz- / Partnerunternehmen ist eine Prüfung der Abrechnung für Sie komplett kostenlos.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Sollten Sie keine Rechtsschutzversicherung haben, hat das
          <b>keine negativen Auswirkungen</b>
          auf Ihren Prüfbericht. Im folgenden Schritt teilen Sie uns bitte Ihren Rechtsschutzversicherer mit.
        </Subtitle>
      </Box>
    </Trans>
  );
};
export default LegalHelp;
